<template>
    <div />
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class AdminHome extends Vue {
    beforeMount() {
        this.$router.push({ name: "my-companies-edition", params: { type: "company" } });
    }

    get companyId() {
        return this.$store.state.user?.company?.id || "";
    }
}

export default toNative(AdminHome);
</script>
